<template>
  <SectionSplit
    class="BondholdersMeet202610 reverse"
    :formats="[]"
    src="../../assets/landing-finances/sunrise-solar.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />

    <p
      v-for="(link, index) in $t('links')"
      :key="index"
      class="links"
      v-html="link" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.BondholdersMeet202610 {
  .Splitter-body {
    max-width: 50rem;
  }

  .body {
    padding: 2rem 0;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Regarding the convened meeting of Sun investment group, UAB bondholders",
    "paragraphs": [
      "A meeting of Sun investment group, UAB bondholders is convened for October 30, 2026.<br>Further information is available in the links:"
    ],
    "links": [
      "<a href=\"https://view.news.eu.nasdaq.com/view?id=1469166&lang=en\" target=\"_blank\">Due to the convened meeting of bondholders of Sun Investment Group UAB</a>",
      "<a href=\"https://view.news.eu.nasdaq.com/view?id=1469210&lang=en\" target=\"_blank\">Supplement to the Notice of the Convening of the Bondholders&#39; Meeting - Publication of Attachments</a>"
    ]
  },
  "lt": {
    "title": "Dėl šaukiamo Sun investment group, UAB obligacijų savininkų susirinkimo",
    "paragraphs": [
      "2026 m. spalio 30 d. šaukiamas Sun investment group, UAB obligacijų savininkų susirinkimas.<br>Išsamesnė informacija pateikiama nuorodose:"
    ],
    "links": [
      "<a href=\"https://view.news.eu.nasdaq.com/view?id=1469166&lang=lt\" target=\"_blank\">Dėl šaukiamo Sun Investment Group UAB obligacijų savininkų susirinkimo</a>",
      "<a href=\"https://view.news.eu.nasdaq.com/view?id=1469210&lang=lt\" target=\"_blank\">Pranešimo apie šaukiamą obligacijų savininkų susirinkimą papildymas - priedų pateikimas</a>"
    ]
  }
}
</i18n>
